import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	versionsListHeader: {
		id: 'software-releases-move-issues-between-versions.version-list.versions-list-header',
		defaultMessage: 'Move to',
		description: 'Header of popup list of all versions in this project',
	},
	otherVersionsButton: {
		id: 'software-releases-move-issues-between-versions.version-list.other-versions-button',
		defaultMessage: 'View all versions',
		description: 'Label on button that opens up the version picker modal.',
	},
});
